import { render, staticRenderFns } from "./GameLinkSwitchDialog.vue?vue&type=template&id=076431f6&scoped=true"
import script from "./GameLinkSwitchDialog.vue?vue&type=script&lang=js"
export * from "./GameLinkSwitchDialog.vue?vue&type=script&lang=js"
import style0 from "./GameLinkSwitchDialog.vue?vue&type=style&index=0&id=076431f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076431f6",
  null
  
)

export default component.exports